export function genRandomKey(): string {
    return '' + Math.floor(Math.random() * 100_000_000);
}

// export function classSelector(className: string): string {
//     return '.' + className;
// }

// export function idSelector(id: string): string {
//     return '#' + id;
// }

// export function hasClasses(htmlElement: HTMLElement, expectedClasses: string[]): boolean {
//     const actualClasses = htmlElement.className.split(' ');

//     return expectedClasses.every(expected => actualClasses.some(actual => actual === expected));
// }

// export function hasExactClasses(htmlElement: HTMLElement, expectedClasses: string[]): boolean {
//     const actualClasses = htmlElement.className.split(' ');

//     const sameLength = expectedClasses.length === actualClasses.length;
//     const everyClass = expectedClasses.every(expected => actualClasses.some(actual => actual === expected));

//     return sameLength && everyClass;
// }
